import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ProductCard from "components/views/ProductCard";
import Spinner from "components/views/atoms/Spinner";

const Wrapper = styled.div`
  //position: relative;
  > * {
    &:not(:last-child),
    &:not(:first-child),
    &:only-child {
      padding: ${({ theme }) => theme.spacer * 3}px 0;
    }
    &:not(:last-child) {
      border-bottom: 1px solid ${({ theme }) => theme.palette.darker};
    }
  }

  &.more-products .banner {
    display: none;
  }
`;

const RecommendedProductsListView = ({ className, list }) => {
  const classes = ["RecommendedProductsListView"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      {list === undefined ? (
        <Spinner relativeToParent />
      ) : (
        list && list.map((l) => <ProductCard key={l.name} product={l} />)
      )}
    </Wrapper>
  );
};

RecommendedProductsListView.displayName = "RecommendedProductsListView";

RecommendedProductsListView.propTypes = {
  className: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.shape({})),
};

RecommendedProductsListView.defaultProps = {
  className: null,
  list: undefined,
};

export default RecommendedProductsListView;
